/* eslint-disable no-console */
import axios from "axios";
import secureStorage from '../controllers/secureStorage.js';

const serverMaintenanceMessage = "Server Under Maintenance. Please contact Baxter XI admin.";
const pendingGetRequests = {};

function getRequestKey(endPoint, parameters, woToken) {
    var serializedParameters = parameters ? JSON.stringify(parameters) : "";
    var authScope = woToken ? "public" : [
        secureStorage.getItem("accountId"),
        secureStorage.getItem("userId"),
        secureStorage.getItem("accessToken")
    ].join("|");

    return [authScope, endPoint, serializedParameters].join("|");
}

var HTTPRequest = {
    async getRequest(endPoint, parameters, woToken){
        var requestKey = getRequestKey(endPoint, parameters, woToken);
        if (pendingGetRequests[requestKey]) {
            return pendingGetRequests[requestKey];
        }

        pendingGetRequests[requestKey] = HTTPRequest.performGetRequest(endPoint, parameters, woToken);

        try {
            return await pendingGetRequests[requestKey];
        } finally {
            delete pendingGetRequests[requestKey];
        }
    },

    async performGetRequest(endPoint, parameters, woToken){
        var response_data;
        var header = {"Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web"}
        if(woToken == undefined){
            header = {Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web",'ip':secureStorage.getItem("ipAddress") }
        }
        if(endPoint.includes("get_zip_wvl")){
            header = {Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File",'ip':secureStorage.getItem("ipAddress") }
        }
        if(endPoint.includes("general_inventory") || endPoint.includes("parse_json_file")){
            header = {Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File",'ip':secureStorage.getItem("ipAddress") }
        }
        await axios({
            method: 'get',
            url: endPoint,
            headers: header,
            params: parameters
            })
            .then(function (response) {
                secureStorage.setItem("serverRunning", true)
                response_data = response.data
            })
            .catch(async function (error) {
                console.log("getRequest", error)
                secureStorage.setItem("serverRunning", true)
                if (error == "Error: Network Error") {
                  response_data = { error: "Network Error" }
                //   secureStorage.setItem("serverRunning", false)
                } else if (error.response.status > 500) {
                  secureStorage.setItem("serverRunning", false)
                  response_data = { error: serverMaintenanceMessage }
                  console.log(serverMaintenanceMessage)
                } else if(error.response.status == 401){
                    var auth_response = await HTTPRequest.authenticate(endPoint)
                    if(auth_response["status"] == "Ok") {
                        //eslint-disable-next-line
                        console.log("Request ka ulit")

                        response_data = await HTTPRequest.performGetRequest(endPoint, parameters, woToken)
                    } else {
                        response_data = {error: "User account has been locked."}
                    }
                } else {
                    if( (typeof error.response.data.error) == "string"){
                        if(error.response.data.error == "Session expired"){
                            alert("Session is already expired. Please login again.")
                            document.addEventListener("DOMContentLoaded", function () {
                                document.getElementById("logoutButton").click();
                            });
                        } else if(error.response.data.error == "Invalid IP for Access Token"){
                            document.addEventListener("DOMContentLoaded", function () {
                                document.getElementById("logoutButton").click();
                            });                    
                        }
                        response_data = {error: error.response.data.error}
                    } else{
                        response_data = {error: error.response.data.error.join(",")}
                    }
                }
              });

        var developerMode = secureStorage.getItem("developerMode")
        if (developerMode != true) {
            if(endPoint.includes("system_module_categories") || endPoint.includes("access_rights")){
                await axios({
                    method: 'PUT',
                    url: endPoint.split("/api")[0] + "/api/v2/backend_sessions/" + secureStorage.getItem("sessionId") + "/update_timestamp",
                    headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web",'ip':secureStorage.getItem("ipAddress") },
                }).then(function (response) {

                }).catch(async function (error) {
                    var regex = /.*login$/;
                    if (!regex.test(location.href)) {
                        //If IP issue
                        if(response_data['error'] == "Invalid IP for Access Token"){
                            let ip = ""
                            await axios({
                                method: 'get',
                                url: '//api.ipify.org?format=json',
                            })
                            .then(function (response) {
                            if (response.data != null) {
                                // console.log(response.data.ip)
                                ip = response.data.ip
                            }
                            })
                            .catch(function () {
                                console.log("Network Error on IPIFY");
                            });
                            //alert(secureStorage.getItem("ipAddress") +">>"+ ip)
                            if(ip != "" && ip != secureStorage.getItem("ipAddress")){
                                alert("Your IP has been changed from "+ secureStorage.getItem("ipAddress") +" to "+ ip +". For your protection we have logged you out, please sign-in again.");
                            } else {
                                alert("Your session has been idle for more than 30 minutes. For your protection we have logged you out, please sign-in again.");
                            }
                        } else {
                            alert("Your session has been idle for more than 30 minutes. For your protection we have logged you out, please sign-in again.");
                        }

                        location.assign(location.origin);
                    }
                });
            }

        }

        return response_data
    },
    
    async postRequest(endPoint, parameters, requestBody, woToken){
        var response_data;
        var header = {"Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web"}
        if(woToken == undefined){
            header = {Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") }
        }
        await axios({
            method: 'post',
            url: endPoint,
            headers: header,
            data: requestBody,
            })
            .then(function (response) {
                secureStorage.setItem("serverRunning", true)
                response_data = response.data
            })
            .catch(async function (error) {
                secureStorage.setItem("serverRunning", true)
                if (error.response.status > 500) {
                  secureStorage.setItem("serverRunning", false)
                  response_data = { error: serverMaintenanceMessage }
                  console.log(serverMaintenanceMessage)
                } else if(error.response.status == 401){
                    var auth_response = await HTTPRequest.authenticate(endPoint)
                    if(auth_response["status"] == "Ok") {
                        //eslint-disable-next-line
                        console.log("Request ka ulit")
                        await HTTPRequest.postRequest(endPoint, parameters, requestBody, woToken)
                    } else {
                        response_data = {error: "User account has been locked."}
                    }
                } else {
                    // console.log(error.response.data.error)
                    if( (typeof error.response.data.error) == "string"){
                        if(error.response.data.error == "Session expired"){
                            alert("Session is already expired. Please login again.")
                            document.addEventListener("DOMContentLoaded", function () {
                                document.getElementById("logoutButton").click();
                            });
                        } else if(error.response.data.error == "Invalid IP for Access Token"){
                            document.addEventListener("DOMContentLoaded", function () {
                                document.getElementById("logoutButton").click();
                            });
                        }
                        response_data = {error: error.response.data.error}
                    } else {
                        var errors = [];
                        if (error.response.data.error != undefined) {
                            errors = error.response.data.error
                        } else {
                            if (error.response.statusText != undefined) errors.push(error.response.statusText)
                            if (error.error != undefined) errors.push(error.error)
                        }
                        response_data = {error: errors.join(',')}
                    }
                }
            });
        return response_data;
    },

    async putRequest(endPoint, parameters, requestBody, woToken){
        var response_data;
        var header = {"Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web"}
        if(woToken == undefined){
            header = {Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':(endPoint.includes("add_on_charges")) ? "BXI-File": "BXI-Web", 'ip':secureStorage.getItem("ipAddress") }
        }
        await axios({
            method: 'put',
            url: endPoint,
            headers: header,
            data: requestBody,
            })
            .then(function (response) {
                secureStorage.setItem("serverRunning", true)
                response_data = response.data
            })
            .catch(async function (error) {
                secureStorage.setItem("serverRunning", true)
                if (error.response.status > 500) {
                  secureStorage.setItem("serverRunning", false)
                  response_data = { error: serverMaintenanceMessage }
                  console.log(serverMaintenanceMessage)
                } else if(error.response.status == 401){
                    var auth_response = await HTTPRequest.authenticate(endPoint)
                    if(auth_response["status"] == "Ok") {
                        //eslint-disable-next-line
                        //console.log("Request ka ulit")
                        await HTTPRequest.putRequest(endPoint, parameters, requestBody, woToken)
                    } else {
                        response_data = {error: "User account has been locked."}
                    }
                } else {
                    if( (typeof error.response.data.error) == "string"){
                        if(error.response.data.error == "Session expired"){
                            alert("Session is already expired. Please login again.")
                            document.addEventListener("DOMContentLoaded", function () {
                                document.getElementById("logoutButton").click();
                            });
                        } else if(error.response.data.error == "Invalid IP for Access Token"){
                            document.addEventListener("DOMContentLoaded", function () {
                                document.getElementById("logoutButton").click();
                            });
                        }
                        response_data = {error: error.response.data.error}
                    }
                    else{
                        response_data = {error: error.response.data.error.join(",")}
                    }

                    // response_data = {error: error.response.data.error.join(",")}
                   // console.log(error.response.statusText)
                    // alert(error.response.data.statusText)
                }
            });
        return response_data;
    },

    async destroyRequest(endPoint, parameters, requestBody, woToken){
        var response_data;
        var header = {"Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web"}
        if(woToken == undefined){
            header = {Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") }
        }
        await axios({
            method: 'delete',
            url: endPoint,
            headers: header,
            data: requestBody,
            })
            .then(function (response) {
                secureStorage.setItem("serverRunning", true)
                response_data = response.data
            })
            .catch(async function (error) {
                secureStorage.setItem("serverRunning", true)
                if (error.response.status > 500) {
                  secureStorage.setItem("serverRunning", false)
                  response_data = { error: serverMaintenanceMessage }
                  console.log(serverMaintenanceMessage)
                } else if(error.response.status == 401){
                    var auth_response = await HTTPRequest.authenticate(endPoint)
                    if(auth_response["status"] == "Ok") {
                        await HTTPRequest.destroyRequest(endPoint, parameters, requestBody, woToken)
                    } else {
                        response_data = {error: "User account has been locked."}
                    }
                } else {
                    if( (typeof error.response.data.error) == "string"){
                        if(error.response.data.error == "Session expired"){
                            alert("Session is already expired. Please login again.")
                            document.addEventListener("DOMContentLoaded", function () {
                                document.getElementById("logoutButton").click();
                            });
                        } else if(error.response.data.error == "Invalid IP for Access Token"){
                            document.addEventListener("DOMContentLoaded", function () {
                                document.getElementById("logoutButton").click();
                            });
                        }
                        response_data = {error: error.response.data.error}
                    }
                    else{
                        response_data = {error: error.response.data.error.join(",")}
                    }
                }
            });
        return response_data;
    },

    async authenticate(endPoint){
        // eslint-disable-next-line
        var response_data;
        var bodyFormData = new FormData();
        bodyFormData.set('email', secureStorage.getItem("email"));
        bodyFormData.append('refresh_token', secureStorage.getItem("refreshToken"));
        bodyFormData.append('grant_type', 'refresh_token');
        await axios({
            method: 'post',
            url: endPoint.split("/api")[0] + '/oauth/token',
            headers: {"Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
            data: bodyFormData,
            })
            .then(function (response) {
                response_data = response.data
                secureStorage.setItem("accessToken", response_data["access_token"]);
                secureStorage.setItem("refreshToken", response_data["refresh_token"]);
                secureStorage.setItem("serverRunning", true)
                response_data = {status: "Ok"}
            })
            .catch(function (error) {
                secureStorage.setItem("serverRunning", true)
                if (error == "Error: Network Error") {
                  response_data = {error: "Network Error"}
                } else if (error.response.status > 500) {
                  secureStorage.setItem("serverRunning", false)
                  response_data = { error: serverMaintenanceMessage }
                  console.log(serverMaintenanceMessage)
                }
                // eslint-disable-next-line

                // console.log("I AM HERE!!!! <<<<")
                response_data = {error: "Error"}
            });

        return response_data;
    },

    async getRequestThirdParty(endPoint, parameters, woToken){
        var header = {'Request-Source':"BXI-Web"}
        if(woToken == undefined){
            header = {Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") }
        }
        var config = {
            method: 'get',
            url: endPoint.replace(/['"]+/g, ''),
            headers: header,
        };

        // console.log(config);
        var response_data;
        await axios(config)
            .then(function (response) {
                response_data = response.data
            })
            .catch(function (error) {
                response_data = []
                //console.log(error)
            });

        return response_data
    },
}


export default HTTPRequest;
